import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const createSchema = z.object({
  name: z.string().min(1, { message: 'Campo obrigatório' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  product_id: optionSchema,
})

export type ProductNfceMappingValidationSchema = z.infer<typeof createSchema>
